@if ({ editable: params.editable() }; as obj) {
  <div>
    @if (dataCheck$ | async) {
      <div
        id="expense-drag-drop"
        cdkDropList
        cdkDropListOrientation="horizontal"
        class="flex w-[704px] items-center justify-start bg-transparent"
        [cdkDropListEnterPredicate]="noReturnPredicate"
        (cdkDropListDropped)="onDragDropChange($event)"
      >
        @for (timePeriod of optionData | async; track timePeriod; let last = $last) {
          <div class="flex items-center space-x-[16px] pl-[16px]">
            <div
              class="flex h-[25px] w-[120px] items-center justify-center px-[5px] text-[12px]"
              cdkDrag
              cdkDragLockAxis="x"
              [cdkDragDisabled]="!obj.editable"
              [ngClass]="get(timePeriod, obj.editable).bg"
              [ngStyle]="{ 'padding-right: 16px;': last }"
            >
              <div [ngClass]="get(timePeriod, obj.editable).txtClass">
                {{ get(timePeriod, obj.editable).text }}
              </div>
            </div>

            @if (!last) {
              <div class="flex items-center"><aux-icon name="ChevronRight" /></div>
            }
          </div>
        }
      </div>
    }
  </div>
}
